import React, { Component } from 'react';
import * as yup from "yup";
import _, { map } from 'lodash';
import moment from "moment-timezone";
// import { connect } from 'react-redux';
import axios from "../../../../Lib/axios";
import { MoreOutlined } from '@ant-design/icons';
import { message, Modal, Select, Drawer } from "antd";

import Dogs from "./Service/Dogs";
// import StaxRegister from '../../../Common/StaxRegister';
import Header from '../../../Common/Component/Header';
import Sidebar from '../../../Common/Component/Sidebar';
import AccountOverview from "./Service/AccountOverview";
import AccountDetails from "./Service/AccountDetails";
import Services from "./Service/Services/Services";
import Invoices from "./Service/Invoices/Invoices";
import Tickets from "./Service/CustomerTickets/Tickets";
import Loader from "../../../Common/Component/Loader";
import CustomerDrawerCollapse from './CustomDrawer/CustomerDrawerCollapse';
import CustomDrawer from "./CustomDrawer/CustomDrawer";
import {errorHandle} from "../../../Common/errorHandle";
import { injectInvoicesStore } from '../../../../Stores/InvoicesStore';
import { formatToCurrency } from '../../../../Tools/formatToCurrency';

const { Option } = Select;
const tabs = [
  'Account Overview',
  'Account Details',
  'Services',
  'Dogs',
  'Invoices',
  'Customer Tickets'
];

// mapping last cleaned
// const LAST_CLEANED = { less_than_2_weeks: 'Less than 2 weeks ago', '1-2_months': '2 to 6 weeks', '2_months_or_more': 'More than 6 weeks' }

class CustomerDetail extends Component {
  state = {
    // This is just for development purpose - uncomment the below line and remove "2,"
    currentTab: this.props?.history?.location?.state?.query?.selectedTab || 0,
    message_count: 0,
    customer: {},
    callLog: {},
    loader: false,
    accountNotes: {},
    serviceOrder: {},
    showSidebar: true,
    invoice_id: '',
    service_order_uuid: '',
    fromOverview: false,
    isExpandPanel: false,
    isServiceDetail: false,
    objService: {},
    reviewServiceOrder: false, 
    deactivateModalVisible: false,
    cancelation_reason: '',
    cancelation_details: '',
    is_reason_select: false,
    last_th_cr_memo:{},
    show_stax: false
  }

  componentDidMount = () => {
    const { history } = this.props;
    const id = history?.location?.state?.query?.id;
    const servicesTab = history?.location?.state?.query?.service_tab;
    if(servicesTab){
      // This redirection applied only  while come from scheduling error page 
      setTimeout(()=>{
        this.setState({
          currentTab: 2,
          reviewServiceOrder:false
        })
      },2000)
    }
    if (id) {
      this.setState({ loader: true });
      this.props.getCustomerDetail(id) // get customer detail
      // this.props.lastThreeCreditMemo({user__uuid:id,limit:3})
      this.props.getInvoiceSummary({ user__uuid: id }) // get invoice summary
      this.props.getServiceOrder({ user__uuid: id, limit: 5 }) // get service order
    }

    ////////////Case Management to Tocket Task Start////////////////
    //Code Added by @codal-jsojitra
    //Add this code here because user that comes from case management and redirect on customer tickets tab
    let is_ticket_details = JSON.parse(localStorage.getItem('is_ticket_details')) || null;
    if (is_ticket_details) {
      if (is_ticket_details.record && is_ticket_details.record.user) {
        //Change the tab as per requirement
        this.setState({
          currentTab: 5
        })
      }
    }
    //Unread message count API
    this.props.getMessagesCount({ user__uuid: id });
    ////////////Case Management to Tocket Task End ////////////////
  }

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    const { callLog, serviceOrder,last_th_cr_memo } = this.state;
    const invoiceSummary = this.props.invoice_summary;
    this.setState({ loader: false });

    // errors
    if (nextProps?.CustomerList?.errors && nextProps?.CustomerList?.errors?.[0]?.includes('exists') && JSON.stringify(nextProps?.CustomerList?.errors) !== JSON.stringify(this.props?.CustomerList?.errors)) {
      message.error(nextProps?.CustomerList?.errors?.[0], 10)
    } else {
      //error handle
      if (Object.keys(nextProps?.ServiceOrder?.errors).length > 0 && nextProps?.ServiceOrder?.errors !== this.props?.ServiceOrder?.errors) {
        this.setState({loader: false});
        errorHandle(nextProps?.ServiceOrder?.errors)
      }
      if (Object.keys(nextProps?.CustomerList?.errors).length > 0 && nextProps?.CustomerList?.errors !== this.props?.CustomerList?.errors) {
        this.setState({loader: false});
        errorHandle(nextProps?.CustomerList?.errors)
      }
      if (Object.keys(nextProps?.UpdateNotification?.errors).length > 0 && nextProps?.UpdateNotification?.errors !== this.props?.UpdateNotification?.errors) {
        this.setState({loader: false});
        errorHandle(nextProps?.UpdateNotification?.errors)
      }
      if (Object.keys(nextProps?.AccountNotes?.errors).length > 0 && nextProps?.AccountNotes?.errors !== this.props?.AccountNotes?.errors) {
        this.setState({loader: false});
        errorHandle(nextProps?.AccountNotes?.errors)
      }
      if (Object.keys(nextProps?.CardList?.errors).length > 0 && nextProps?.CardList?.errors !== this.props?.CardList?.errors) {
        this.setState({loader: false});
        errorHandle(nextProps?.CardList?.errors)
      }
      if (Object.keys(nextProps?.PricingHistory?.errors).length > 0 && nextProps?.PricingHistory?.errors !== this.props?.PricingHistory?.errors) {
        this.setState({loader: false});
        errorHandle(nextProps?.PricingHistory?.errors)
      }
      if (Object.keys(nextProps?.Invoice?.errors).length > 0 && nextProps?.Invoice?.errors !== this.props?.Invoice?.errors) {
        this.setState({loader: false});
        errorHandle(nextProps?.Invoice?.errors)
      }
      if (Object.keys(nextProps?.AllMessages?.errors).length > 0 && nextProps?.AllMessages?.errors !== this.props?.AllMessages?.errors) {
        this.setState({loader: false});
        errorHandle(nextProps?.AllMessages?.errors)
      }
      if (Object.keys(nextProps?.UpdateCard?.errors).length > 0 && nextProps?.UpdateCard?.errors !== this.props?.UpdateCard?.errors) {
        this.setState({loader: false});
        errorHandle(nextProps?.UpdateCard?.errors)
      }
      if (Object.keys(nextProps?.AddCard?.errors).length > 0 && nextProps?.AddCard?.errors !== this.props?.AddCard?.errors) {
        this.setState({loader: false});
        errorHandle(nextProps?.AddCard?.errors)
      }
      if (Object.keys(nextProps?.DeleteCard?.errors).length > 0 && nextProps?.DeleteCard?.errors !== this.props?.DeleteCard?.errors) {
        this.setState({loader: false});
        errorHandle(nextProps?.DeleteCard?.errors)
      }
      if (Object.keys(nextProps.VoidInvoice.errors).length > 0 && nextProps.VoidInvoice.errors !== this.props.VoidInvoice.errors) {
        // display error messsage
        this.setState({ loader: false});
  
        if (nextProps?.VoidInvoice?.errors?.message) {
          message.error(nextProps?.VoidInvoice?.errors?.message, 10);
        }
        else {
          errorHandle(nextProps?.VoidInvoice?.errors)
        }
      }
    }
    ////////////////////////////////////////////////////

    // get customer detail
    if (Object.keys(nextProps?.CustomerList?.customer).length > 0) { 
      this.setState({ customer: nextProps?.CustomerList?.customer });
    }

    // get call logs
    if (Object.keys(nextProps?.CallLog?.logList).length > 0
      && JSON.stringify(nextProps?.CallLog?.logList) !== JSON.stringify(this.props?.CallLog?.logList)) {
      this.setState({ callLog: nextProps?.CallLog?.logList });
    }

    // Add call logs
    if (Object.keys(nextProps?.CallLog?.log).length > 0
      && JSON.stringify(nextProps?.CallLog?.log) !== JSON.stringify(this.props?.CallLog?.log)) {
      this.setState({ callLog: { ...callLog, results: [...(callLog?.results || []), nextProps?.CallLog?.log] } });
    }

    // Get service order
    if (Object.keys(nextProps?.ServiceOrder?.data).length > 0
      && JSON.stringify(nextProps?.ServiceOrder?.data) !== JSON.stringify(serviceOrder)) {
      this.setState({ serviceOrder: nextProps?.ServiceOrder?.data?.results });
    }

    // Invoice summary
    if (Object.keys(nextProps?.Invoice?.invoiceSummary).length > 0
      && JSON.stringify(nextProps?.Invoice?.invoiceSummary) !== JSON.stringify(invoiceSummary)) {
      this.props.SetInvoiceSummary(nextProps?.Invoice?.invoiceSummary);
    }

    // Customer Ticket Code by @codal-jsojitra
    // Get unread message count
    if (Object.keys(nextProps.MessageCount.data).length > 0 && nextProps.MessageCount.data !== this.props.MessageCount.data) {
      this.setState({
        message_count: nextProps.MessageCount.data.count
      })
    }
    if (Object.keys(nextProps.MessageCount.data).length > 0 && nextProps.MessageCount.data !== this.props.MessageCount.data) {
      // Display error messsage
    }
  }

  // convert date time from utc to local time
  UTCToLocal = (date) => {
    let stillUtc = moment.utc(date).toDate();
    return moment(stillUtc).local();
  }

  // convert date time from local to utc
  localToUTC = (date) => {
    return moment.utc(date)
  }

  // tab change
  tabChange = (e) => {
    this.setState({
      currentTab: e,
      showSidebar: true,

    });
    const id = this.props.history.location.state.query.id;
    this.props.getMessagesCount({ user__uuid: id });
  };

  viewServiceDetail = (isServiceDetail, objService) => {
    this.setState({
      isServiceDetail,
      objService
    })
  }  

  // toggle side bar
  toggleSidebar = (value) => {
    this.setState({showSidebar: value})
  }

  // toggle show register stax info
  staxRegisterToggle = (value) => {
    this.setState({show_stax: value})
  }

  // render basic detail
  renderBasicDetails = ({status}) => {
    const { customer, serviceOrder } = this.state;
    const invoiceSummary = this.props.invoice_summary;
    let a = moment(), b = moment(customer?.created_at);
    const years = a.diff(b, 'year');
    b.add(years, 'years');
    const months = a.diff(b, 'months');

    const basicDetail = [
      { key: 'Account #', value: customer?.account_number },
      { key: 'Franchise', value: !_.isEmpty(customer?.field_office) ? `${customer?.field_office?.city}, ${customer?.field_office?.state}` : '' },
      ...status !== "pending" ? [{ key: 'Joined', value: `${years}y ${months}m` }] : [],
      ...status !== "pending" ? [{ key: 'Last Service', value: customer?.last_service ? this.UTCToLocal(customer?.last_service).format('MMM DD, YYYY') : '' }] : [],
      ...status !== "pending" ? [{ key: 'Next Service', value: serviceOrder?.[0]?.next_service_date ? this.UTCToLocal(serviceOrder?.[0]?.next_service_date).format('MMM DD, YYYY') : '' }] : [],
      ...status !== "pending" ? [{ key: 'Open Balance', value: `$ ${invoiceSummary?.total_open_balance ? formatToCurrency(invoiceSummary?.total_open_balance) : '0.00'}` }] : []
    ]

    return map(basicDetail, (item, index) =>
      <div key={`basic${index}`} className={"dcell"}>
        <span><b>{item?.key}</b></span>
        <span>{item?.value}</span>
      </div>
    )
  };

  setTab = (tab) => {
    this.setState({
      currentTab: tab
    })
  }

  updateSummary = (customer_id) =>
  {
    this.props.getInvoiceSummary({ user__uuid: customer_id });
  }

  // render tab
  renderTab = () => {
    const {
      currentTab,
      customer,
      service_order_uuid,
      invoice_id,
      fromOverview,
      reviewServiceOrder,
      creditMemo_uuid
    } = this.state;
    const { history } = this.props;
    const id = history?.location?.state?.query?.id;
    const hear_about_us = history?.location?.state?.query?.hear_about_us;
    const customer_satisfaction_score = history?.location?.state?.query?.customer_satisfaction_score;

    switch (currentTab) {
    case 0:
      return <AccountOverview
        customerId={id}
        tabChange={this.tabChange}
        onClearFromOverview={() => this.setState({fromOverview:false})} 
        onInvoiceLineClick={(invoice_id, service_order_uuid) => {
          this.setState({invoice_id, service_order_uuid, fromOverview: "view"})
        }}
        onInvoicePaymentHistoryClick={(invoice_id) => {
          this.setState({invoice_id, fromOverview: "payment_history"})
        }}
        onCreditMemoClick={(invoice_id) => {
          this.setState({invoice_id, fromOverview: "credit_memo"})
        }}
        customer={customer}
        customer_satisfaction_score={customer_satisfaction_score}
        // APIs
        updateCustomer={this.props.updateCustomer}
        getCustomerDetail={this.props.getCustomerDetail}
        getServiceOrder={this.props.getServiceOrder}
        getAccountNotes={this.props.getAccountNotes}
        addAccountNotes={this.props.addAccountNotes}
        getAuthorizedUserList={this.props.getAuthorizedUserList}
        sendEmailReminder={this.props.sendEmailReminder}
        getCardList={this.props.getCardList}
        getInvoiceList={this.props.getInvoiceList}
        getInvoiceSummary={this.props.getInvoiceSummary}
        getAllMessages={this.props.getAllMessages}
        suspendAccount={this.props.suspendAccount}
        getLastThreePayment={this.props.getLastThreePayment}
        getServiceOrderEnquiry={this.props.getServiceOrderEnquiry}
        getCreditMemoDetails={this.props.getCreditMemoDetails}
        lastThreeCreditMemo={this.props.lastThreeCreditMemo}
        postPaymentLog={this.props.postPaymentLog}

        // Reducers
        customerList={this.props.CustomerList}
        serviceOrder={this.props.ServiceOrder}
        accountNotes={this.props.AccountNotes}
        authorizedUser={this.props.AuthorizedUser}
        emailReminder={this.props.EmailReminder}
        cardList={this.props.CardList}
        Invoice={this.props.Invoice}
        LastThreeCreditMemo={this.props.Invoice?.LastThreeCreditMemo?.results}
        AllMessages={this.props.AllMessages}
        serviceOrderEnquiry={this.props.ServiceOrderEnquiry}
        last_th_cr_memo={this.state.last_th_cr_memo}
        PostPaymentLog={this.props.PostPaymentLog}

        //
        viewServiceDetail={this.viewServiceDetail}
        LastThreePayment = {this.props.LastThreePayment}
      />
    case 1:
      return (
        <AccountDetails
          customerId={id}
          tabChange={this.tabChange}
          hearAboutUs={hear_about_us}
          fieldOffice={this.state?.customer?.field_office?.uuid}
          onClearFromOverview={() =>this.setState({fromOverview:false})} 

          //APIs
          getCustomerDetail={this.props.getCustomerDetail}
          getServiceOrder={this.props.getServiceOrder}
          updateCustomer={this.props.updateCustomer}
          getNotification={this.props.getNotificationById}
          updateNotificationById={this.props.updateNotificationById}
          getCardList={this.props.getCardList}
          updateCard={this.props.updateCard}
          deleteCard={this.props.deleteCard}
          addNewCard={this.props.addNewCard}
          getBlockList={this.props.getBlockList}
          getUserList={this.props.getUserList}
          addBlockUser={this.props.addBlockUser}
          deleteBlockUser={this.props.deleteBlockUser}
          getAccountNotes={this.props.getAccountNotes}
          addAccountNotes={this.props.addAccountNotes}
          getAuthorizedUserList={this.props.getAuthorizedUserList}
          addAuthorizedUser={this.props.addAuthorizedUser}
          deleteAuthorizedUser={this.props.deleteAuthorizedUser}
          getPricingHistory={this.props.getPricingHistory}
          sendEmailReminder={this.props.sendEmailReminder}
          getFieldTechnicianList={this.props.getFieldTechnicianList}
          GoogleApi={this.props.GoogleApi}
          getGeocodeAddress={this.props.getGeocodeAddress} // api
          resetGeocodeAddress={this.props.resetGeocodeAddress} // api

          // Reducers
          customerList={this.props.CustomerList}
          serviceOrder={this.props.ServiceOrder}
          GetNotification={this.props.getNotification}
          updateNotification={this.props.UpdateNotification}
          updateCardDetail={this.props.UpdateCard}
          deleteCardDetail={this.props.DeleteCard}
          addCard={this.props.AddCard}
          blockList={this.props.BlockList}
          userList={this.props.UserList}
          accountNotes={this.props.AccountNotes}
          cardList={this.props.CardList}
          notificationList={this.props.NotificationList}
          authorizedUser={this.props.AuthorizedUser}
          pricingHistory={this.props.PricingHistory}
          emailReminder={this.props.EmailReminder}
          fieldTechnician={this.props.FieldTechnician}

          //function
          deActivateCustomerConfirm={this.deActivateCustomerConfirm}
          activateCustomer={this.reActivateCustomer}

          {...this.props}
        />
      )
    case 2:
      return <Services
        {...this.props}
        setTab={this.setTab}
        customerId={id}
        tabChange={this.tabChange}
        customer={customer}
        toggleSidebar={this.toggleSidebar}
        onViewService={this.props.onViewService}
        onClearFromOverview={() => this.setState({fromOverview:false})}

        // APIs
        getServiceOrder={this.props.getServiceOrder}
        viewService={this.props.viewService}
        getPauseService={this.props.getPauseService}
        pauseService={this.props.pauseService}
        updatePauseService={this.props.updatePauseService}
        getPauseReason={this.props.getPauseReason}
        deletePauseService={this.props.deletePauseService}
        editService={this.props.editService}
        getFranchiseById={this.props.getFranchiseById}
        getServiceOrderById={this.props.getServiceOrderById}
        getFieldOfficeById={this.props.getFieldOfficeById}
        pricingCalculator={this.props.pricingCalculator}
        resetCheckZipcode={this.props.resetCheckZipcode}
        resetPricingCalculator={this.props.resetPricingCalculator}
        getServiceOrderEnquiry={this.props.getServiceOrderEnquiry}
        updateServiceOrderEnquiry={this.props.updateServiceOrderEnquiry}
        checkZipCode={this.props.checkZipCode}
        getCustomerDetail={this.props.getCustomerDetail}
        addNewCard={this.props.addNewCard}
        addServiceOrder={this.props.addServiceOrder}
        updateServiceOrder={this.props.updateServiceOrder}
        getCardList={this.props.getCardList}
        deleteCard={this.props.deleteCard}
        getServiceHistory={this.props.getServiceHistory}
        getGeocodeAddress={this.props.getGeocodeAddress}
        resetGeocodeAddress={this.props.resetGeocodeAddress}
        getServiceOrderFilter={this.props.getServiceOrderFilter}
        getWorkOrderFilter={this.props.getWorkOrderFilter}
        getFieldTechnicianFilter={this.props.getFieldTechnicianFilter}
        getWorkOrderList={this.props.getWorkOrderList}
        deactivateServiceOrder={this.props.deactivateServiceOrder}

        // Reducers
        customerList={this.props.CustomerList}
        serviceOrder={this.props.ServiceOrder}
        service={this.props.Service}
        zipcodeCheck={this.props.ZipcodeCheck}
        pricingCalc={this.props.PricingCalc}
        serviceOrderEnquiry={this.props.ServiceOrderEnquiry}
        CardList={this.props.CardList}
        AddCard={this.props.AddCard}
        GoogleApi={this.props.GoogleApi}
        serviceOrderFilter={this.props.ServiceOrderFilter}
        workOrderFilter={this.props.WorkOrderFilter}
        fieldTechnicianFilter={this.props.FieldTechnicianFilter}
        workOrderList={this.props.WorkOrderList}
        isServiceDetail={this.state.isServiceDetail}
        objService={this.state.objService}
        viewServiceDetail={this.viewServiceDetail}
        deactivatedServiceOrder={this.props.deactivatedServiceOrder}
        reviewServiceOrder={reviewServiceOrder}
        deActivateCustomerConfirm={this.deActivateCustomerConfirm}
        activateCustomer={this.activateCustomer}
      />
    case 3:
      return <Dogs
        customerId={id}
        tabChange={this.tabChange}
        customer={customer}
        onClearFromOverview={() => this.setState({fromOverview:false})} 
        // APIs
        addPet={this.props.addPet}
        updatePet={this.props.updatePet}
        deletePet={this.props.deletePet}
        getPets={this.props.getPets}
        getServiceOrder={this.props.getServiceOrder}
        updateServiceOrder={this.props.updateServiceOrder}
        updatePartialServiceOrder={this.props.updatePartialServiceOrder}

        // Reducers
        pet={this.props.Pet}
        serviceOrder={this.props.ServiceOrder}
      />
    case 4:
      return <Invoices
        customerId={id}
        tabChange={this.tabChange}
        customer={customer}
        invoice_id={invoice_id}
        service_order_uuid={service_order_uuid}
        fromOverview={fromOverview}
        creditMemo_uuid={creditMemo_uuid}
        updateSummary={this.updateSummary}

        // APIs
        getInvoiceList={this.props.getInvoiceList}
        getInvoiceCreditMemoList={this.props.getInvoiceCreditMemoList}
        addPaymentLog={this.props.addPaymentLog}
        addManualPaymentLog={this.props.addManualPaymentLog}
        deletePaymentLog={this.props.deletePaymentLog}
        getCustomers={this.props.getCustomers}
        getServiceOrderNumberList={this.props.getServiceOrderNumberList}
        addInvoice={this.props.addInvoice}
        addManualInvoice={this.props.addManualInvoice}
        editInvoice={this.props.editInvoice}
        voidInvoice={this.props.voidInvoice}
        deleteInvoice={this.props.deleteInvoice}
        getInvoiceById={this.props.getInvoiceById}
        getServiceOrderById={this.props.getServiceOrderById}
        addInvoiceLineItem={this.props.addInvoiceLineItem}
        editInvoiceLineItem={this.props.editInvoiceLineItem}
        deleteInvoiceLineItem={this.props.deleteInvoiceLineItem}
        getInvoiceSummary={this.props.getInvoiceSummary}
        resendInvoice={this.props.resendInvoice}
        printInvoices={this.props.printInvoices}
        exportPDFStatement={this.props.exportPDFStatement}
        getAccountListing={this.props.getAccountListing}
        getPaymentHistory={this.props.getPaymentHistory}
        getPaymentHistoryNew={this.props.getPaymentHistoryNew}
        getCardList={this.props.getCardList}
        addNewCard={this.props.addNewCard}
        finalizeInvoice={this.props.finalizeInvoice}
        getStaffUsers={this.props.getStaffUsers}
        getInvoiceDescription={this.props.getInvoiceDescription}
        refundPayment={this.props.refundPayment}
        getSalesTax={this.props.getSalesTax}
        postPaymentLog={this.props.postPaymentLog}
        getWorkOrderList={this.props.getWorkOrderList}
        getWorkOrderDetail={this.props.getWorkOrderDetail}
        getCreditMemoDetails={this.props.getCreditMemoDetails}
        getWorkOrderTypeDescription={this.props.getWorkOrderTypeDescription}
        addCreditMemo={this.props.addCreditMemo}
        addCreditMemoLineItem={this.props.addCreditMemoLineItem}
        getCustomerDetail={this.props.getCustomerDetail}
        addUnattachedPayment={this.props.addUnattachedPayment}
        cleanPaymentResponse={this.props.cleanPaymentResponse}
        remainingCreditBalance={this.props.remainingCreditBalance}
        deleteAccountInvoice={this.props.deleteAccountInvoice}
        invoiceProcess = {this.props.invoiceProcess}

        // Reducers
        Invoice={this.props.Invoice}
        InvoiceCreditMemoList={this.props.InvoiceCreditMemoList}
        CustomerList={this.props.CustomerList}
        ServiceOrder={this.props.ServiceOrder}
        PDFExportStatement={this.props.PDFExportStatement}
        GetAccountList={this.props.GetAccountList}
        PaymentHistory={this.props.PaymentHistory}
        PaymentHistoryNew = {this.props.PaymentHistoryNew}
        cardList={this.props.CardList}
        addCard={this.props.AddCard}
        GetManualy={this.props.GetManualy}
        InvoiceDescription={this.props.InvoiceDescription}
        VoidInvoice={this.props.VoidInvoice}
        workOrderList={this.props.WorkOrderList}
        WorkOrderDetail={this.props.WorkOrderDetail}
        WorkOrderTypeDescription={this.props.WorkOrderTypeDescription}
        PostPaymentLog={this.props.PostPaymentLog}
        RemainingCreditBalance={this.props.RemainingCreditBalance}
        DeleteInvoice={this.props.DeleteInvoice}
        InvoiceProcess={this.props.InvoiceProcess}
      />
    case 5:
      return <Tickets
        //API
        getAllMessages={this.props.getAllMessages}
        getUserList={this.props.getUserList}
        getGroupList={this.props.getGroupList}
        createNewTickets={this.props.createNewTickets}
        MessageReplies={this.props.MessageReplies}
        UpdateTickets={this.props.UpdateTickets}
        readTickets={this.props.readTickets}
        getMessagesCount={this.props.getMessagesCount}
        onClearFromOverview={() => this.setState({fromOverview:false})} 
        getReasons={this.props.getReasons}
        
        // Reducers
        AllMessages={this.props.AllMessages}
        UserList={this.props.UserList}
        getCSVData={this.props.getCSVData}
        GroupList={this.props.GroupList}
        NewTicket={this.props.NewTicket}
        RepliesonTicket={this.props.RepliesonTicket}
        UpdateMesssage={this.props.UpdateMesssage}
        customerId={id}
        CustomerList={this.props.CustomerList}
        getReasonList={this.props.getReasonList}
      />
    default:
      return <AccountOverview
        getAccountInfo={this.props.getAccountInfo} />
    }
  }

  expandCollapse = (isExpand) => {
    if(this.state.customer?.status!=='pending'){
      this.setState({
        isExpandPanel: isExpand
      })
    }
  }

  /**
   * AUTHOR: Ritesh Solanki
   * <DP-3494>Activate a Pending Residential Customer, Initiate</DP-3494>
   */
  activateCustomer = () => {
    this.setState({reviewServiceOrder: true}, () => {
      this.tabChange(2)
    });    
  }

  /**
   * AUTHOR: Ritesh Solanki
   * <DP-3496>Deactivate a Pending Residential Customer</DP-3496>
   */
  deActivateCustomerConfirm = () => {
    this.setState({
      deactivateModalVisible: true
    })
  }

  /**
   * AUTHOR: Ritesh Solanki
   * <DP-3496>Deactivate a Pending Residential Customer</DP-3496>
   */
  dectivateCustomer = () => {
    const { cancelation_reason, cancelation_details, is_reason_select } = this.state;
    const schema = yup.object().shape({
      is_reason_select: yup.bool(),
      cancelation_reason: yup.string().required("Please select a reason."),
      ...(is_reason_select ? {cancelation_details: yup.string().required("Please provide a reason.")} : null),
    });
    const data = { cancelation_reason, cancelation_details, is_reason_select };
    schema.validate(data, { abortEarly: false }).then(() => {
      this.setState({deactivateModalVisible:false});
      this.setState({ is_reason_select: false, errors: {} });
      const customerId = this.props?.history?.location?.state?.query?.id;
      axios.patch(`crm/customer-user/${customerId}/`, {is_active: false, cancelation_reason: cancelation_reason, cancelation_details: cancelation_details}).then((response) => {
        message.success(`Customer deactivated successfully.`, 10);
        setTimeout(() => {
          this.props.history.goBack();
        }, 1100);
      }).catch(error => {
        message.error(`Error occurred while deactivating customer.`, 10);
      });
    }).catch((error) => {
      let err_data = {};
      map(error.inner, (item) => {
        err_data[item.path] = item.message;
      });
      this.setState({ errors: err_data, is_reason_select: false });
    });
  }

  reActivateCustomer = () => {
    const customerId = this.props?.history?.location?.state?.query?.id;

    axios.patch(`crm/customer-user/${customerId}/`, {is_active: true}).then((response) => {
      message.success(`Customer activated successfully.`, 10);
      setTimeout(() => {
        this.props.history.goBack();
      }, 1100);
    }).catch(error => {
      message.error(`Error occurred while activating customer.`, 10);
    });
  }

  render() {
    const {
      currentTab,
      customer,
      loader,
      message_count,
      showSidebar,
      isExpandPanel,
      deactivateModalVisible,
      cancelation_reason,
      cancelation_details,
      errors, 
      show_stax
    } = this.state;

    const { history } = this.props;
    const id = history?.location?.state?.query?.id;
    const name = customer?.first_name ? `${customer?.first_name} ${customer?.last_name}` : '';

    return (
      <div id="wrapper">
        <div className="content-area">
          {/* Header */}
          <Header placeholder={'Acc Number, Customer Name, Address(Billing), Phone Number, Email Address'} />

          {/* Sidebar */}
          <Sidebar />

          <div className="container">
            {loader && <Loader />}
            <div className={showSidebar ? "md-container" : ""} style={{maxWidth: '95%'}}>
              <div className="filter_wrapper">
                <ul className="breadcrumb">
                  <li className={"cursor_pointer"}><span onClick={() => window.location.assign('/residential')}>Customer</span></li>
                  <li><span>{name}</span></li>
                </ul>
              </div>
              <div className="residential-wrapper">
                <div className="res-head pb-0">
                  <div className="flex ai-center mb-20">
                    <div className="user-info">
                      <h3>{name}</h3>
                      <span className={`status ${(customer?.status?.toLowerCase() === "pending") ? "info-status" : ((!customer?.is_active) ? "primary-status" : "active")} drk`}>
                        {customer?.status}
                      </span>
                    </div>

                    <div className="user-detail">
                      {this.renderBasicDetails({status: customer?.status?.toLowerCase() || "inactive"})}
                      {customer?.status?.toLowerCase() !== 'pending' &&
                        <div className="position-relative status-dropdown">
                          <span className="status-d-arrow">
                            <MoreOutlined />
                          </span>
                          <ul className="status-dropdownmenu">
                            <li><a href="#" onClick={(e) => { e.preventDefault(); this.deActivateCustomerConfirm();}} >Deactivate</a></li>
                          </ul>
                        </div>
                      }
                    </div>

                    {
                      customer?.status === "pending" && <React.Fragment>
                        <button className="btn btn-gray" onClick={() => { this.deActivateCustomerConfirm() }}>Deactivate Customer</button>
                        <button className="btn btn-primary" onClick={() => {  this.activateCustomer() }}>Activate Customer</button>
                      </React.Fragment>
                    }
                    <Modal
                      visible={deactivateModalVisible}
                      okText={"Deactivate"}
                      cancelText={"Cancel"}
                      onOk={() => {
                        this.dectivateCustomer()
                        
                      }}
                      onCancel={() => {
                        this.setState({deactivateModalVisible:false, cancelation_reason: '', cancelation_details: '', is_reason_select: false, errors:{} })
                      }}
                      className="delete_user_modal"
                      width={400}
                    >   
                      <h3>Deactivate Customer</h3>
                      <p>Please provide a reason for deactivating this customer.</p>
                      <React.Fragment>
                        <div className="field-group">
                          <label>Reason<sup>*</sup></label>
                          <Select
                            showSearch
                            optionFilterProp="children"
                            placeholder={"Select reason"}
                            value={cancelation_reason || ''}
                            onChange={(e) => {
                              if (e) {
                                if (e === "other") {
                                  this.setState({is_reason_select: true});
                                } else {
                                  this.setState({is_reason_select: false});
                                }
                                this.setState({cancelation_reason: e});
                              } else {
                                this.setState({cancelation_reason: ''});
                              }
                            }}
                          >
                            <Option value="">Select reason</Option>
                            <Option value="death_of_dog">Loss of Pet</Option>
                            <Option value="service">Service Quality</Option>
                            <Option value="moving">Moving</Option>
                            <Option value="competition">Pricing</Option>
                            <Option value="other">Other</Option>
                          </Select>
                          {errors?.['cancelation_reason'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.['cancelation_reason']}</label> : ''}
                        </div>
                        {cancelation_reason === "other" && <div className="field-group">
                          <textarea
                            className="textarea-gray"
                            rows="5"
                            name="cancelation_details"
                            type="text"
                            maxLength={200}
                            placeholder={"Add cancellation details here."}
                            value={cancelation_details}
                            onChange={(e) => {
                              if (e) {
                                this.setState({cancelation_details: e?.target?.value});
                              } else {
                                this.setState({cancelation_details: ""});
                              }
                            }} 
                          />
                          {errors?.['cancelation_details'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.['cancelation_details']}</label> : ''}
                        </div>}
                      </React.Fragment>
                    </Modal>
                  </div>
                  <ul className="tabs dark">
                    {
                      map(tabs, (item, index) =>
                        <li
                          key={`tab${index}`}
                          className={customer?.status?.toLowerCase() === "pending" && item?.toLowerCase() === "invoices" ? 'hide-tab' : currentTab === index ? 'active' : ''}
                          onClick={(e) => { e.preventDefault(); this.setState({reviewServiceOrder:false}, () => {this.tabChange(index) }) }}
                        >
                          <span className="flex ai-center">
                            {item}
                            {item.toLowerCase()?.includes('tickets') && <div className="count">{message_count}</div>}
                          </span>
                        </li>
                      )
                    }
                  </ul>
                </div>
                <div className="res-body">
                  {this.renderTab()}
                </div>
              </div>
            </div>
            
            {showSidebar && !isExpandPanel ? <div className="side-drawer-collapsed">
              <CustomerDrawerCollapse
                expandCollapse={this.expandCollapse}
                // staxRegisterToggle={this.staxRegisterToggle}
              />
            </div> : ''}

            {showSidebar && isExpandPanel ? <div className="side-drawer rdrawer-expanded">
              <CustomDrawer 
                customerId={id}
                CallLog={this.props.CallLog} // reducer
                getCallLogList={this.props.getCallLogList}
                RepresentativeList={this.props.RepresentativeList} // reducer
                getRepresentativeList={this.props.getRepresentativeList}
                addCallLog={this.props.addCallLog}
                updateCallLog={this.props.updateCallLog}
                getAccountNotes={this.props.getAccountNotes}
                addAccountNotes={this.props.addAccountNotes}
                accountNotes={this.props.AccountNotes}
                expandCollapse={this.expandCollapse}
              />
            </div>: ''}

            {/* <Drawer
              width={'420'}
              closable={false}
              visible={show_stax}
              className="drawer-wrapper create_ticket_drawer"
            >
              <StaxRegister
                customerId={id}
                clearKey={this.clearKey}
                staxRegisterToggle={this.staxRegisterToggle}
                {...this.props}
              />
            </Drawer> */}
          </div>
        </div>
      </div>
    );
  }
}

export default injectInvoicesStore ()(CustomerDetail);
